export const COURSES_ID_NAME = {
  1: 'SW개발 보안 기본과정',
  2: 'Java 시큐어코딩',
  4: '클라우드 시스템 취약점 분석',
  6: '.NET 시큐어코딩',
  7: '클라우드기반의 SW개발보안 프로세스',
  8: 'Python 시큐어코딩',
  10: 'C 시큐어코딩',
  11: 'SW 구현단계에서의 49개 보안약점',
};

export const LANGUAGE_OPTIONS = [
  { languageId: 0, languageName: '공통', color:'default' },
  { languageId: 1, languageName: 'Python', color:'success' },
  { languageId: 2, languageName: 'Java', color:'warning' },
  { languageId: 3, languageName: 'C', color:'success' },
  { languageId: 4, languageName: 'C++', color:'warning' },
  { languageId: 5, languageName: 'C#', color:'error' },
  { languageId: 6, languageName: 'NodeJS', color:'primary' },
  { languageId: 7, languageName: 'JavaScript', color:'secondary' }
];

/** 그룹 과정 선택 탭 (courseType) */
export const COURSE_TYPE_TABS = [
  { value: 'SOFTWARE_SECURITY', label: '소프트웨어 개발보안' },
  { value: 'INFORMATION_SECURITY', label: '정보보안' },
  { value: 'PROGRAMMING', label: '프로그래밍' },
  { value: 'ETC', label: '기타' },
];